import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import ReactPaginate from 'react-paginate';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Badge, Card, Col, Container, Row, } from "react-bootstrap";
import Moment from 'moment';
import '../Blog.css';
import ClickInfos from "./admin/ClickInfos";

function Blog() {
    const params = new URLSearchParams(useLocation().search);
    const [data, setData] = useState([]);
    const [blogbyid, setBlogById] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const clickInfos = new ClickInfos();

    let tag = params.get("tag") ? '&tag='+params.get("tag") : '';
    const fetchItems = async (page) => {
        const response = await fetch(process.env.REACT_APP_API_URLSF+`/api/showblogbasic?page=${page + 1} ${tag}`);
        const data = await response.json();
        setData(data.blogs);
        setPageCount(Math.ceil(data.totalblogs / data.limit));
    };

    useEffect(() => {
        fetchItems(currentPage).then(r => r);
    }, [currentPage]);

    function parseTags(array){
        let resultj = '';
        if(typeof array !== 'undefined'){
            array.forEach(item => {
                if (Array.isArray(item)) {
                    resultj += parseTags(item);
                } else if (typeof item === 'object' && item !== null) {

                    for (const [key, value] of Object.entries(item)) {
                        let val =` <a href="?tag=${value}" id="${key}" class="badge rounded-pill bg-secondary">${value}</a>, `
                        resultj += val;
                    }
                } else {

                    let val =` <a href="?tag=${item}" class="badge rounded-pill bg-secondary">${item}</a>, `
                    resultj += val;
                }
            });
            return resultj.slice(0, -2);
        }
    }

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };
    const blogById = async (id) => {
        const response = await fetch(process.env.REACT_APP_API_URLSF+`/api/blog/`+id);
        const data = await response.json();
        setBlogById(data);
        clickInfos.getUserIp('blog');
    };

return (
        <React.Fragment>
            <section id="signup" className="signup-section">
                            <Container className="container-fluid">
                                <Row className="mb-3">
                                    <Col className="col-lg-6">
                                        <ReactPaginate
                                            style={{ opacity: 0.50 }}
                                            previousLabel={"Précédent"}
                                            nextLabel={"Suivant"}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakLinkClassName="page-link"
                                            renderOnZeroPageCount={null}
                                        />

                                        <Container style={{ maxHeight: "900px",
                                            overflow: "auto" }} className="mb-4">
                                            {data.map((item) => (
                                                <Card style={{ opacity: 0.33 }}  className="navbar-shrink pointer mb-3" onClick={() => blogById(item.id)}>
                                                    <Card.Body>
                                                        <Card.Title className="text-muted">{item.title}</Card.Title>
                                                        <Card.Subtitle className="mb-2 text-muted"><span>Créé le</span> {Moment(item.datepost).format("DD/MM/YYYY")}</Card.Subtitle>
                                                            <Card.Text className="text-muted">
                                                            {item.tags.map((tags, index) => (
                                                                <Badge key={tags[index]} pill bg="secondary">{tags[index]}</Badge>
                                                            ))
                                                            }
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            ))}
                                        </Container>


                                        <ReactPaginate
                                            style={{ opacity: 0.50 }}
                                            previousLabel={"Précédent"}
                                            nextLabel={"Suivant"}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakLinkClassName="page-link"
                                            renderOnZeroPageCount={null}
                                        />
                                    </Col>
                                    <Col className="col-lg-6">
                                        <Row>
                                            <span className="mb-3">
                                                <p dangerouslySetInnerHTML={{__html:parseTags(blogbyid.tags)}} />
                                                {blogbyid.id
                                                    &&
                                                    <span className="text-end">Ajouté le {Moment(blogbyid.datepost).format("DD/MM/YYYY")}</span>
                                                }
                                            </span>
                                            <hr/>
                                            <span className="mb-3">
                                                    <h5>{blogbyid.title}</h5>
                                                </span>
                                            <span className="mb-3"><p dangerouslySetInnerHTML={{__html: blogbyid.post}} /></span>

                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
            </section>
        < /React.Fragment>
    );
}
export default Blog;